export const Config = {
    baseUrls: {
        localhost: 'http://localhost:9000/',
        dev: 'https://ekshield-dev.ektar.com/',
        "dev-pgs": 'https://ekshield-dev-pgs.ektar.com/',
        demo: 'https://softtoken-demo.ektar.io/',
        uat: 'https://softtoken-uat.ektar.io/',
    },
    totpInterval: 30,
    success: "SUCCESS",
    networkStatus: {
        500: "500 INTERNAL_SERVER_ERROR",
    },
    totpLength: 6,
    pinlength: 6,
    deviceTypes: [
        "MOBILE",
        "CAR",
        "TABLET",
        "SMART_TV",
        "WEARABLE",
        "UNKNOWN",
        "DESKTOP",
    ],
    devicePlatforms: {unknown: "UNKNOWN", ios: "IOS", android: "ANDROID"},
    pinValidationStatus: {},
};

export const endPoints = {
    registration: "/api/ekshield-svc-ekbank/v1/st-registration/configure",
    getRegisteredDevicesApi: (
        userId: string | null,
        page: number,
        size: number
    ) =>
        `/api/st-registration/v1/registrations/user/${userId}?page=${page}&size=${size}`,
    getDevicesByRegId: (regId: string | null) =>
        `/api/st-registration/v1/registrations/${regId}`,
    deleteRegisteredDeviceApi: (regId: string) =>
        `/api/st-registration/v1/registrations/${regId}`,

    totpHandshakeApi: "/api/ekshield-svc-ekbank/v1/st-registration/totp-handshake",

    getAuthTokenApi: "/api/ekshield-svc-ekbank/v1/mock-customer-login-2",

    completeRegistration: "/api/ekshield-svc-ekbank/v1/st-registration/complete",

    highRiskTotpValidation:
        "/api/ekshield-svc-ekbank/v1/st-security/high-risk-totp-validate",

    lowRiskTotpValidation:
        "/api/ekshield-svc-ekbank/v1/st-security/low-risk-totp-validate",

    preRegistrationValidation:
        "/api/ekshield-svc-ekbank/v1/st-registration/pre-register-validate",
    ftlApi: (deviceId: string) =>
        `/api/ekshield-svc-ekbank/v1/st-registration/ftl/${deviceId}`,

    keyExchange: "/api/security/sc-key-exchange",

    instanceConfig: "/api/st-security/v1/instance-configs",

    pnAuthorize: "/api/ekshield-svc-ekbank/v1/st-security/authorize",

    pnTsnStatus: (transactionId: string) =>
        `/api/ekshield-svc-ekbank/v1/st-security/authorize/transaction/${transactionId}/status`,

    portfolioApi: "/api/ekshield-svc-ekbank/v1/my-portfolio",

    myBeneficiariesApi: (page: number, size: number, type: string) =>
        `/api/ekshield-svc-ekbank/v1/customers/my-beneficiaries?page=${page}&size=${size}&type=${type}`,

    myaccountsApi: "/api/ekshield-svc-ekbank/v1/customers/my-accounts",

    OWN_ACCOUNT_TRANSFER: "/api/ekshield-svc-ekbank/v1/transfers/own-account",

    INTRA_BANK_TRANSFER: "/api/ekshield-svc-ekbank/v1/transfers/intra-bank",

    INTER_BANK_TRANSFER: "/api/ekshield-svc-ekbank/v1/transfers/inter-bank",

    INTERNATIONAL_TRANSFER:
        "/api/ekshield-svc-ekbank/v1/transfers/international-bank",

    latestTransactionList: (
        accountId: string,
        page: number,
        size: number,
        sortby: string = "lastModifiedDate",
        order: string = "DSC"
    ) =>
        `/api/ekshield-svc-ekbank/v1/accounts/${accountId}/transactions?page=${page}&size=${size}&sortBy=${sortby}&direction=${order}`,

    recentTransactionList: (
        page: number,
        size: number,
        sortby: string = "lastModifiedDate",
        order: string = "DSC"
    ) =>
        `/api/ekshield-svc-ekbank/v1/customers/my-transactions?page=${page}&size=${size}&sortBy=${sortby}&direction=${order}`,

    getMyRegistrations: "/api/ekshield-svc-ekbank/registrations/mine",

    logOut: "/api/ekshield-svc-ekbank/logout",

    getQRImage: "/api/st-oauth2/v1/auth/qr-login-image",

    QrLoginStatus: (qrSessionId: string) =>
        `/api/st-oauth2/v1/auth/check-qr-login-status/${qrSessionId}`,
};

export const transferWeights = {
    ST_LOWRISK_TOTP: "ST_LOWRISK_TOTP",
    ST_LOWRISK_STOTP: "ST_LOWRISK_STOTP",
    ST_HIGHRISK_TOTP: "ST_HIGHRISK_TOTP",
    ST_HIGHRISK_STOTP: "ST_HIGHRISK_STOTP",
};

export const statusTypes = {
    INITIATED: "INITIATED",
    AUTHORIZED: "AUTHORIZED",
    DECLINED: "DECLINED",
    TIMEDOUT: "TIMEDOUT",
    PENDING: "PENDING",
    COMPLETED: "COMPLETED",
};

export const typeOptions = [
    {label: "Own Account", value: "OWN_ACCOUNT_TRANSFER"},
    {label: "With In Bank", value: "INTRA_BANK_TRANSFER"},
    {label: "Other Banks", value: "INTER_BANK_TRANSFER"},
    {label: "International", value: "INTERNATIONAL_TRANSFER"},
];

export const debitOrCredit = {
    debit: "DEBIT",
    credit: "CREDIT",
};

export const commonStatus = {
    success: "SUCCESS",
    failed: "FAILED",
};

export const locationConfig = {
    apiKey: "1feed4c2d40045cea959d093821d3f8a152faee067e823fb7da88da1",
};

export const apiServiceHeadersConfig = {
    ektarOrgId: "x-ek-org-id",
    secureSessionId: "x-ek-sc-session-id",
    symmetricKey: "x-ek-symmetric-key",
    clientPublicKey: "x-ek-client-public-key",
    latitude: "x-latitude",
    longitude: "x-longitude",
    mfaChallengePayload: "X-MFA-Challenge-Payload",
    channelType: "x-ek-channeltype",
}

